<template>
	<div class="my-wallet">
		<div class="my-title clearfix">
			<span class="">我的积分</span>
		</div>
		<div class="money">
			<div class="money-number">
				<span class="title">账户积分：</span>
				<span class="price">{{userInfo.points}}</span>
			</div>
		</div>
		<el-tabs v-model="activeName" class="tabs-line">
			<el-tab-pane label="积分明细" name="first"></el-tab-pane>
			<el-table :data="list.data" stripe style="width: 100%">
				<el-table-column prop="create_time" label="日期">
				</el-table-column>
				<el-table-column prop="value" :formatter="valueFormat" label="积分">
				</el-table-column>
				<el-table-column prop="describe" label="描述">
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="paging">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
					:current-page.sync="currentPage" :page-size="100" layout="prev, pager, next, jumper" :total="list.total">
				</el-pagination>
			</div>
		</el-tabs>
	</div>
</template>

<script>
	import * as UserApi from '@/api/user'
	import * as LogApi from '@/api/points/log'
	export default {
		data() {
			return {
				currentPage: 1,
				activeName: 'first',
				list: [],
				// 会员信息
				userInfo: {},
			}
		},
		created() {
			this.getUserInfo()
			this.getList()
		},
		methods: {
			// 获取会员信息
			getUserInfo() {
			  const app = this
			  UserApi.info()
			    .then(result => {
			      app.userInfo = result.data.userInfo
			    })
			},
			getList(){
				let app = this
				LogApi.list({ page: app.currentPage })
				  .then(result => {
				    // 合并新数据
				    app.list = result.data.list
				  })
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.currentPage = val
				this.getList()
			},
			valueFormat(row){
				return (row.value > 0 ? '+' : '') + row.value
			}
		}
	}
</script>

<style lang="scss">
	@import "../../assets/css/my-wallet.scss"
</style>
